import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { selectSelectedAmountOfUnitsToPurchase, selectShoppingCartOrThrow } from 'app/pages/order/redux/order-selector';
import { OrderService } from 'app/pages/order/services/order-service';
import { NavigationService } from 'app/services/navigation-service';
import { SummaryPageContent } from 'app/pages/order/summary/summary-page-content';

export const SummaryPage: FunctionComponent = () => {
    const shoppingCart = useSelector(selectShoppingCartOrThrow);
    const amountOfUnitsToPurchase = useSelector(selectSelectedAmountOfUnitsToPurchase);
    const {
        wifiUnitInformation: { amountOfOwnedWifiUnits, maximumNumberOfUnits },
        freeUnit,
    } = shoppingCart;
    const amountOfUnitsToReceive = OrderService.getAmountOfWifiUnitsToReceive(!!freeUnit, amountOfUnitsToPurchase);

    if (amountOfOwnedWifiUnits + amountOfUnitsToReceive > maximumNumberOfUnits) {
        return <Navigate to={NavigationService.ERROR_CANNOT_ORDER_MORE} replace={true} />;
    }

    return <SummaryPageContent />;
};
